import * as React from "react";
import PropTypes from 'prop-types';

const SvgBogoTag = props => {
  if (props.id !== "_svgbogotag") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 20 20" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10.492 3.498l5.294.026a.48.48 0 01.477.48l.015 5.296.008.008-.008.008-6.454 6.471a1.438 1.438 0 01-2.037 0L4.02 12.01a1.446 1.446 0 010-2.041l6.462-6.48.01.01zm2.544 3.268a1.185 1.185 0 001.679 0 1.192 1.192 0 000-1.683 1.185 1.185 0 00-1.679 0 1.192 1.192 0 000 1.683z" fill="#E71324" /></svg>;
};

SvgBogoTag.displayName = "_svgbogotag";
SvgBogoTag.propTypes = {
  id: PropTypes.string
};
SvgBogoTag.defaultProps = {
  id: ''
};
export default SvgBogoTag;